import React from 'react'
import {ShareButtons, findApiV4Link} from 'shared'
import {DonateButtonCombo} from 'fepp'

export const Sharing = (props) => {
  const shareUrl = findApiV4Link({ofObject: props.fundraisingEvent, withRel: 'platform'})

  return <div className="fundraising-events-show-sharing" id="share">
    <div className="container">
      <div className="row">
        <div className="col-md-24 text-center">
          <h1 className="font-lg">{I18n.t('fundraising_events.show.sharing.headline')}</h1>

          <DonateButtonCombo fundraisingEvent={props.fundraisingEvent} gaAction='click donate_button__bottom' />

          <h2 className="font-sm">{I18n.t('fundraising_events.show.sharing.share_call_to_action')}</h2>
          <div className="row">
            <div className="col-md-6 offset-md-9">
              <ShareButtons
                fundraisingEvent
                platforms={['facebook', 'twitter', 'link', 'whatsapp', 'messenger', 'instagram']}
                mobileOnly={['whatsapp', 'messenger']}
                shape='round'
                shareUrl={shareUrl}
                gaLabel='fundraising events: footer'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
